import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import linkifyHtml from 'linkify-html';
import { escapeHtml, sanitizeHtml } from '@local/sanitize-html';

export function formatPlainText(text, literals) {
  const newText = escapeHtml(String(text ?? '').replaceAll('\n\n', '\n'));
  return unsafeHTML(
    sanitizeHtml(
      linkifyHtml(
        String.raw`<p class="mt-2 text">
        ${newText.split('\n').join('</p><p class="mt-2 text">')}
      </p>`,
        {
          defaultProtocol: 'https',
          target: '_blank',
          rel: 'noreferrer',
          className: 'link link--generated',
          attributes: {
            title: literals.externalLink
          }
        }
      )
    )
  );
}
